/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindProductBrandValuesQueryResponse,
  FindProductBrandValuesQueryParams,
} from "../types/FindProductBrandValues.ts"

export const findProductBrandValuesQueryKey = (
  params?: FindProductBrandValuesQueryParams
) =>
  [
    { url: "/v1/product/find-product-brand-values" },
    ...(params ? [params] : []),
  ] as const

export type FindProductBrandValuesQueryKey = ReturnType<
  typeof findProductBrandValuesQueryKey
>

/**
 * @summary Find product brand values
 * {@link /v1/product/find-product-brand-values}
 */
export async function findProductBrandValues(
  params?: FindProductBrandValuesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductBrandValuesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/product/find-product-brand-values`,
    params,
    ...requestConfig,
  })
  return res
}

export function findProductBrandValuesQueryOptions(
  params?: FindProductBrandValuesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findProductBrandValuesQueryKey(params)
  return queryOptions<
    ResponseConfig<FindProductBrandValuesQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindProductBrandValuesQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findProductBrandValues(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find product brand values
 * {@link /v1/product/find-product-brand-values}
 */
export function useFindProductBrandValues<
  TData = ResponseConfig<FindProductBrandValuesQueryResponse>,
  TQueryData = ResponseConfig<FindProductBrandValuesQueryResponse>,
  TQueryKey extends QueryKey = FindProductBrandValuesQueryKey,
>(
  params?: FindProductBrandValuesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductBrandValuesQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findProductBrandValuesQueryKey(params)

  const query = useQuery(
    {
      ...findProductBrandValuesQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
